<script setup lang="ts">
import { Dialog, Button } from 'primevue';
import { useLanguageStore } from '../../translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';

defineExpose({
  show
});

let showCallbacks: ShowCallbacks | null = null;
const visible = ref(false);
const saveDisabled = ref(false);

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

async function show(options: ShowOptions) {
  visible.value = true;
  saveDisabled.value = options.saveDisabled;

  const promise = new Promise<UnsavedChangesActions>((resolve, reject) => {
    showCallbacks = {
      resolve
    };
  });

  return promise;
}

function resolveShow(action: UnsavedChangesActions) {
  if (showCallbacks === null) return;
  showCallbacks.resolve(action);
  showCallbacks = null;
  visible.value = false;
}

export type UnsavedChangesActions = 'Save' | 'Discard' | 'Cancel';

interface ShowCallbacks {
  resolve: (action: UnsavedChangesActions) => void;
}

interface ShowOptions {
  saveDisabled: boolean;
}

</script>

<template>
  <Dialog v-model:visible="visible" modal @hide="resolveShow('Cancel')" :header="translations.unsavedChanges.title">
    <span>{{ translations.unsavedChanges.description }}</span>
    <template #footer>
      <Button :disabled="saveDisabled" @click="resolveShow('Save')" :label="translations.generic.save"></Button>
      <Button @click="resolveShow('Discard')" severity="danger" :label="translations.generic.discard"></Button>
    </template>
  </Dialog>
</template>
